<template>
	<div class="small-12 flex page settings addCompany animated fadeIn" v-if="loaded && user">
		<primary-nav :user="user"/>
		<div class="small-12 large-10 pageContentWrap">
			<div class="small-12 pageContent">
				<div class="small-12 centerColumn">
					<div class="small-12 details">
						<settings-nav/>
						<steps :user="user"/>
					</div>
				</div>
			</div>
		</div>
	</div>
	<loading-spinner :loaded="loaded" v-else/>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'

	// Import the components
	import UserFooter from '@/components/framework/footer/UserFooter.vue'
	import LoadingSpinner from '@/components/framework/helpers/LoadingSpinner.vue'
	import PrimaryNav from '@/components/framework/nav/PrimaryNav.vue'
	import SettingsNav from '@/components/settings/shared/SettingsNav.vue'
	import Steps from '@/components/settings/company/add/Steps.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Index',

		/*
		**  Register the components
		*/

		components: {

			LoadingSpinner,
			PrimaryNav,
			SettingsNav,
			Steps

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			user: null,
			loaded: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
		**  Do this first
		*/

		created() {

			// Get the user
			this.getUser();

		},

        /*
		**  Set up the methods
		*/

		methods: {

			getUser: function() {

				// Get the user doc
				usersModel.doc(firebaseAuth.currentUser.uid).get()
				.then(doc => {

					if (!doc.exists) return;

					// Set the prop
					this.user = doc.data();

				})
				.then(() => {

					// Set the prop
					this.loaded = true;

				})
				.catch(error => {

					// Send to bugsnag
					this.reportAuthBugsnagError({
						title: 'Add Company Index - Get User Document',
						errorType: 'Firestore Database',
						section: 'Add Company',
						component: 'Index',
						error: error
					});

				});

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>